import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { selectSelectedModal } from "../../Modal";
import {
  checkIcon,
  crossRedIcon,
  serviceRightPaneNodeIcon,
  crossIcon,
} from "../../../../assets/icons";
import { MOUSE_EVENTS } from "../../../../constants";
import { selectSelectedNodeDetails } from "../../../../pages/DataModels";

const { setSelectedModal } = modalActions;
const { MOUSE_DOWN } = MOUSE_EVENTS;

const RenderNodes = ({ nodes, name }) => {
  return (
    !!nodes && (
      <>
        <div className="text-blue-700 text-xs py-2 font-medium">{name}</div>
        <div className="grid grid-cols-2 text-xs">
          {nodes.map((node) => (
            <React.Fragment key={node.name}>
              <div className="mb-2">{node.name}</div>
              <div className="mb-2">{node.description}</div>
            </React.Fragment>
          ))}
        </div>
      </>
    )
  );
};

const NodeDescriptionModal = () => {
  const dispatch = useDispatch();
  const ref = useRef(null);
  const selectedModal = useSelector(selectSelectedModal);
  const selectedNode = useSelector(selectSelectedNodeDetails);

  const [node, setNode] = useState();
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (selectedModal) setShouldShow(selectedModal);
  }, [selectedModal]);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (shouldShow && ref.current && !ref.current.contains(e.target))
        dispatch(setSelectedModal(null));
    };
    document.addEventListener(MOUSE_DOWN, checkIfClickedOutside);
    return () =>
      document.removeEventListener(MOUSE_DOWN, checkIfClickedOutside);
  }, [shouldShow, dispatch]);

  useEffect(() => {
    if (selectedNode) {
      setNode(selectedNode.card);
    }
  }, [selectedNode]);

  const handleCloseModal = useCallback(() => {
    dispatch(setSelectedModal(null));
  }, [dispatch]);

  return (
    <>
      <div
        className={classNames(
          "fixed z-[999] duration-300 transition-opacity ease-in-out  w-1/3 left-[91px] top-[130px]  backdrop-blur-0 flex items-center",
          {
            " inline-block opacity-100": !!shouldShow,
            " w-0 h-0 opacity-0": !shouldShow,
          }
        )}
        ref={ref}
      >
        {node && (
          <div className=" w-full font-sans mx-auto my-2 p-4 bg-white border rounded-lg shadow-xl min-w-20 min-h-min max-h-[36rem] overflow-y-auto overflow-x-hidden">
            <div className="flex items-center mb-2 justify-between">
              <div className="flex items-center">
                <img
                  src={serviceRightPaneNodeIcon}
                  alt="web-hook-icon"
                  className="h-4 w-4 mr-3"
                />
                <h6 className="text-sm font-bold ">{node.name}</h6>
              </div>
              <button
                className="hover:opacity-80 active:opacity-100"
                type="button"
                onClick={handleCloseModal}
              >
                <img src={crossIcon} alt="delete" className="w-4" />
              </button>
            </div>

            <div className="rounded-lg justify-center text-xs mb-2 ">
              {node.description}
            </div>
            <div className="grid grid-cols-2 text-xs space-y-1">
              <div>Multi Input</div>
              <div
                className={classNames("text-red-700 flex flex-row", {
                  "text-green-700": node.multiInput,
                })}
              >
                <div>
                  <img
                    src={node.multiInput ? checkIcon : crossRedIcon}
                    className="h-4 w-4 rounded-lg mr-2"
                    alt="status-icon"
                  />
                </div>
                {node.multiInput ? "Yes" : "No"}
              </div>
              <div>Multi Outputs</div>
              <div
                className={classNames("text-red-700 flex flex-row", {
                  "text-green-700": node.multiOutput,
                })}
              >
                <div>
                  <img
                    src={node.multiOutput ? checkIcon : crossRedIcon}
                    className="h-4 w-4 rounded-lg mr-2"
                    alt="status-icon"
                  />
                </div>
                {node.multiOutput ? "Yes" : "No"}
              </div>
            </div>
            <RenderNodes nodes={node.outputs} name="Output Link points" />
            <RenderNodes nodes={node.inputs} name="Input Link points" />
            <RenderNodes nodes={node.config} name="Parameters" />
          </div>
        )}
      </div>
    </>
  );
};

export default NodeDescriptionModal;
